// @flow

import type { AuthState } from '../store/reducer/auth';
import { SOCIAL_LOGIN_TYPES } from '../config/constants';

/**
 * Tells if user is currently in the social login flow
 * @param state
 * @returns {Boolean}
 */
const isSocialLogin = (state: AuthState) => {
  const { socialLogin, authType } = state;

  return !!(
    SOCIAL_LOGIN_TYPES.indexOf(authType) > -1
    && socialLogin
    && socialLogin.identityToken
    && socialLogin.type
  );
};

export default isSocialLogin;
